import React from 'react'

/**
 * Logo Zoom: persegi biru dengan kamera putih. Warnanya tetap, tidak mengikuti
 * `currentColor`, karena logo merek harus dikenali sama di tema terang maupun gelap.
 * Gambar ini tiruan sederhana, bukan berkas resmi. Untuk materi yang membutuhkan
 * logo resmi, ganti dengan aset dari panduan merek Zoom.
 */
export default function ZoomLogo({ size = 16, className = '', style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      style={{ flexShrink: 0, display: 'inline-block', verticalAlign: 'middle', ...style }}
      role="img"
      aria-label="Zoom"
    >
      <rect width="24" height="24" rx="6" fill="#0B5CFF" />
      <rect x="4" y="8" width="10" height="8" rx="2" fill="#fff" />
      <path d="M15.5 11.2 19.6 8.6a.5.5 0 0 1 .77.42v5.96a.5.5 0 0 1-.77.42L15.5 12.8z" fill="#fff" />
    </svg>
  )
}
